export enum TimeZone {
  EUROPE_PARIS = "Europe/Paris",
  INDIAN_REUNION = "Indian/Reunion",
}

export enum OfferTabsLabel {
  JOBS = "EMPLOI",
  SERVICES = "SERVICES",
  TRAINING = "FORMATION",
}

export enum CandidateFieldFeatures {
  NONE = 0,
  FILTERABLE = 1,
  SPOTLIGHT = 2,
  READONLY = 4,
  VISIBLE_CER = 8,
  STATISTICS_ACTIVE = 16,
  MUTUAL_ACROSS_ORGANISATIONS = 32,
  REQUIRED_CER = 64,
  ENABLE_DIAGNOSIS = 128,
  REQUIRED_DIAGNOSIS = 256,
  ENABLE_EXPORT = 512,
  FILTERABLE_EPT = 1024,
  ENABLE_INTERVIEW_EXIT = 2048,
  REQUIRED_INTERVIEW_EXIT = 4096,
  READONLY_CER = 8192,
}

export enum CoachingStepRuleKey {
  CER = "cer",
  ACTION = "action",
  EPT = "ept",
}

export enum AppointmentReminderFeature {
  ACTION = "action",
  WORKSHOP = "workshop",
}
